module.exports = __webpack_public_path__ + "img/awards.6afdf08.webp";